import React, { useState, useEffect } from 'react'

const CheckBoxGroup = props => {
  // props from parent to this file
  const { sendoptions, checkboxObj, commonStyle, setdisableOk } = props
  const { align, design, width, length } = commonStyle
  // state variables for this file
  const [checkBox, setCheckBox] = useState([])
  // onchange handleChange is trigred and options are sent back to parent
  const handleChange = (e, val, index) => {
    const checkboxData = checkBox
    checkboxData[index].selected = !checkboxData[index].selected
    setdisableOk(false)
    setCheckBox([...checkboxData])
    sendoptions(checkboxData)
  }

  // useEffect is used to render checkbox values for every change in checkbox abd checkboxobj
  useEffect(() => {
    setCheckBox(checkboxObj.length > 0 ? checkboxObj : [])
  }, [checkBox, checkboxObj])

  return (
    <div
      className={`custom-form-control ${design} ${align} ${length >= 2 ? 'first-last' : 'no-list'}`}
      style={{ width }}
    >
      {/* checkbox is mapped to render checkbox value dynamically */}
      {checkBox &&
        checkBox.map((val, i) => (
          <div key={i} className='checkbox-list'>
            <input
              type='checkbox'
              name={val.value}
              id={`genrecheckbox${i}`}
              checked={val.selected}
              onChange={event => handleChange(event, val.value, i)}
            />
            <label htmlFor={`genrecheckbox${i}`}>{val.text}</label>
          </div>
        ))}
      <br />
      <br />
    </div>
  )
}

export default CheckBoxGroup
